module.exports = __webpack_public_path__ + "img/wxm.b8521b8f.jpg";